import {observable, action, makeAutoObservable} from "mobx"

class ModalStore {
    @observable show: boolean = false;
    @observable confirm: boolean = false;
    @observable message!: string | React.JSX.Element;
    @observable callback?: (result: boolean) => void;

    constructor() {
        makeAutoObservable(this);
    }

    public modal(message: string | React.JSX.Element = "", confirm: boolean, callFunction: (result: boolean) => void) {
        this.show = true;
        this.confirm = confirm;
        this.message = message;
        this.callback = callFunction;
    }

    @action
    public setShow(show: boolean) {
        this.show = show;
    }

    @action
    public toggleShow() {
        this.show = !this.show;
    }
}

const modalStore = new ModalStore();

export default modalStore;